<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Users</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" :disabled="!validateMaxUser" id="btnmaxUser">
              New User
            </v-btn>
            <v-btn color="primary" @click="onBulkUsers()" class="mt-4" id="btnBulUpload" >
              Bulk User Upload
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <div class="row">
          <div class="col">
            <v-text-field
              id="firstName"
              v-model="selectedObj.firstName"
              label="First Name*"
              required
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="lastname"
              v-model="selectedObj.lastName"
              label="Last Name*"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              id="emial"
              v-model="selectedObj.email"
              label="Email*"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="selectedObj.phone"
              id="phonenumber"
              label="Phone"
            ></v-text-field>
          </div>
        </div>
        <div class="row" v-show="!isEditPassword">
          <div class="col">
            <v-text-field
              id="passwordHint"
              v-model="selectedObj.passwordhint"
              label="Password Hint*"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="password"
              v-model="selectedObj.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              name="input-10-1"
              label="Password*"
              hint="At least 6 characters"
              counter
              @click:append="show1 = !show1"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-select
              id="userRole"
              v-model="selectedObj.userRole"
              :items="UserTypes"
              label="User Type*"
              item-text="roleName"
              item-value="id"
              return-object
            ></v-select>
          </div>
          <div class="col"></div>
        </div>
        <div class="row">
          <div class="col">
            <div class="float-right">
              <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    @click="onOpenSetPassword()"
                    v-show="isEditPassword"
                  >
                    Set Password
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Password</span>
                  </v-card-title>
                  <v-card-text>
                    <v-divider></v-divider>
                    <Notification :notify="notifyPassword" />
                    <v-row>
                      <v-col>
                        <v-text-field
                          id="passwordHint"
                          v-model="selectedObj.passwordhint"
                          label="Password Hint*"
                        >
                        </v-text-field
                      ></v-col>
                      <v-col>
                        <v-text-field
                          id="password"
                          v-model="selectedObj.password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          name="input-10-1"
                          label="Password*"
                          hint="At least 6 characters"
                          counter
                          @click:append="show1 = !show1"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      id="btnClose"
                      color="blue darken-1 mr-2"
                      text
                      @click="dialog = false"
                    >
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="onSavePassword()" id="btnPassSave">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-btn
                class="mr-4"
                color="primary"
                @click="onSave()"
                :loading="loading"
                :disabled="loading"
                id="btnSave"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                  <th class="text-left">Type</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.userRole.roleName }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <div class="row" v-show="isEdit && userId != 0">
        <div class="col mt-2">
          <v-divider></v-divider>
          <UserDevice :userId="userId" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import UserDevice from "@/components/UserDevice";
import * as api from "@/api";

export default {
  name: "OrgUsers",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    UserDevice
  },
  created() {
    this.getUserRoles(true);
    this.getUsersByPagin();
    this.validateMaxUserCount();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    onNew() {
      this.isEdit = true;
      this.isEditPassword = false;
      this.selectedObj.id = 0;
      this.selectedObj.userRoleId = 0;
      this.selectedObj.countryId = 0;
      this.selectedObj.firstName = "";
      this.selectedObj.lastName = "";
      this.selectedObj.email = "";
      this.selectedObj.gender = "";
      this.selectedObj.address1 = "";
      this.selectedObj.address2 = "";
      this.selectedObj.city = "";
      this.selectedObj.state = "";
      this.selectedObj.country = "";
      this.selectedObj.zip = "";
      this.selectedObj.phone = "";
      this.selectedObj.password = "";
      this.selectedObj.passwordhint = "";
      this.selectedObj.active = false;
      this.selectedObj.userRole = null;
      this.selectedObj.isOrganizationUser = false;
      this.notify.type = 0;
    },
    validateMaxUserCount() {
      //organization/validate/max-users
      new Promise((resolve, reject) => {
        api
          .getAll("user/organization/validate/max-users")
          .then((response) => {
            this.validateMaxUser = response.data.IsValied;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getUsersByPagin();
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);
      this.getUsersByPagin();
    },
    getUsersByPagin() {
      this.list = [];
      let that = this;
      that.overlay = true
      new Promise((resolve, reject) => {
        api
          .getByPagin("user", this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
            that.overlay = false
          })
          .catch((error) => {
            reject(error);
            that.overlay = false
          });
      });
    },
    onSave() {
      if (!this.validateFrom()) {
        this.selectedObj.isOrganizationUser = true;
        const jsonStringValues = JSON.stringify(this.selectedObj);
        console.log(jsonStringValues);

        this.loading = true;
        new Promise((resolve, reject) => {
          api
            .update("user", this.selectedObj)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message =
                  this.selectedObj.id === -1
                    ? "Record successfully saved."
                    : "Record successfully updated.";
                this.loading = false;
                this.isEdit = false;
                this.validateMaxUserCount();
                this.getUsersByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } 
              else 
              {      
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
                this.loading = false;
                }
            })
            .catch((error) => {
               if (error.message == "Request failed with status code 409") {
            
                this.notify.type = 4;
                this.notify.errors.push("Email address already exist.");
                this.loading = false;
                reject(error);
              }
              else{
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
              reject(error);
              }
            });
        });
      }
    },
    onSavePassword() {
      this.notifyPassword.errors = [];
      //this.notifyPassword.errors.splice(0, this.notify.errors.length);
      this.notifyPassword.type = 4;

      if (this.selectedObj.passwordhint === "") {
        this.notifyPassword.errors.push("Password hint required.");
        return true;
      }
      if (this.selectedObj.password === "") {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }
      if (this.selectedObj.password != null && this.selectedObj.password.length < 6) {
        this.notifyPassword.errors.push("The password should have a minimum of 6 characters.");
        return true;
      }

      var obj = {
        id: this.selectedObj.id,
        password: this.selectedObj.password,
        passwordhint: this.selectedObj.passwordhint,
      };
      new Promise((resolve, reject) => {
        api
          .update("user/set-password", obj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.dialog = false;
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Password successfully saved."
                  : "Password successfully updated.";
              this.getUsersByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });

      this.dialog = false;
    },
    onOpenSetPassword() {
      this.notifyPassword.errors = [];
    },
    onEdit(obj) {
      this.isEdit = true;
      this.isEditPassword = true;
      obj.password = "";
      this.selectedObj = Object.assign({}, obj);
      this.userId = this.selectedObj.id;

      //this.getUserRoles(this.selectedObj.isOrganizationUser);
    },
    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getUsersByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
    },
    validateFrom() {
      console.log(this.selectedObj.userRole);

      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.errors = [];
      this.notify.type = 4;

      if (this.selectedObj.firstName == "") {
        this.notify.errors.push("First name required.");
        return true;
      }
      if (this.selectedObj.lastName == "") {
        this.notify.errors.push("Last name required.");
        return true;
      }
      if (this.selectedObj.email == "") {
        this.notify.errors.push("Email required.");
        return true;
      }
      /*if(!this.isEmailValid())
        {
          this.notify.errors.push('Invalied Email.');
          return true;
        }*/
      if (this.selectedObj.passwordhint === "" && !this.isEditPassword) {
        this.notify.errors.push("Password hint required.");
        return true;
      }
      if (this.selectedObj.password === "" && !this.isEditPassword) {
        this.notify.errors.push("Password required.");
        return true;
      }
      if (this.selectedObj.userRole == null) {
        this.notify.errors.push("User type required.");
        return true;
      }
      /*
      if (
        this.selectedObj.isOrganizationUser &&
        this.selectedObj.organization == null
      ) {
        this.notify.errors.push("Organization required.");
        return true;
      }*/
      return false;
    },
    getUserRoles(isOrganization) {
      this.UserTypes = [];
      new Promise((resolve, reject) => {
        api
          .getByID("user-role/organization", isOrganization)
          .then((response) => {
            console.log(response);
            this.UserTypes = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onBulkUsers() {
      this.$router.push("/organization/bulk_users");
    }

  },
  data() {
    return {
      list: [],
      listFilted: [],
      Organizatios: [],
      isEdit: false,
      isEditPassword: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      notifyPassword: {
        type: 0,
        message: "",
        errors: [],
      },
      Genders: [
        { code: "M", name: "Male" },
        { code: "F", name: "Female" },
      ],
      UserTypes: [],
      //UserTypes: [
      //  { id: 1, name: "Admin" },
      //  { id: 2, name: "User" },
      //],
      date: "", // new Date().toISOString().substr(0, 10),
      //dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      reg: '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,24}))$/',
      show1: false,
      password: "Password",
      dialog: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      validateMaxUser: false,
      userId: 0,
      overlay: false
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgUsers.vue